<template>
  <div class="llre-wrap">
    <modal
      name="editLuckyRunner"
      @before-close="onClose"
      class="editluckyRunner llre-modal"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      width="90%"
      :maxWidth="560"
    >
      <div class="llre-dialog">
        <div class="llre-dialog-header">
          <div class="llre-dialog-header-left">
            <span class="llre-dialog-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 7h-3V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H4"/>
                <path d="M5 7l1 14h12l1-14"/>
                <path d="M9 11h6"/>
                <path d="M9 15h4"/>
              </svg>
            </span>
            <div>
              <h2 class="llre-dialog-title">Edit Lucky LiveRunner</h2>
              <p class="llre-dialog-sub">Update gift details and sent status for this runner</p>
            </div>
          </div>
          <button class="llre-close-btn" type="button" title="Close" @click="$modal.hide('editLuckyRunner')">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        <div class="llre-dialog-body">
          <div class="llre-field">
            <label class="llre-label">Who</label>
            <input class="llre-input" v-model="luckyRunnerData.runnerName">
          </div>
          <div class="llre-field">
            <label class="llre-label">Sent</label>
            <input class="llre-input" v-model="luckyRunnerData.presentSentDate" placeholder="YYYY-MM-DD">
          </div>
          <div class="llre-field">
            <label class="llre-label">What</label>
            <input class="llre-input" v-model="luckyRunnerData.presentContent">
          </div>
          <div class="llre-field">
            <label class="llre-label">Note</label>
            <textarea class="llre-textarea" v-model="luckyRunnerData.note"></textarea>
          </div>
        </div>

        <div class="llre-dialog-footer">
          <button class="llre-cancel-btn" type="button" @click="$modal.hide('editLuckyRunner')">Cancel</button>
          <button class="llre-save-btn" type="button" v-on:click="Save()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
              <polyline points="17 21 17 13 7 13 7 21"/>
              <polyline points="7 3 7 8 15 8"/>
            </svg>
            Save
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import LuckyLiveRunnerService from "../../../services/luckyLiveRunner"

export default {
  name: "edit-lucky-live-runner",
  data: () => ({
   luckyRunnerData:{
      "id": '',
      "runDate": "",
      "runName": "",
      "raceDateTime":"",
      "trainerName": "",
      "runStartTime": "",
      "runnerId": '',
      "runnerName": "",
      "presentSentDate": "",
      "presentContent": "",
      "note": ''
    }
  }),
  props: {
    runnerData: {},
    show: false
  },
  methods: {
    onClose() {
      // this.gift = ""
      this.$emit("closed", true)
    },
    openEditModal() {
      Object.assign(this.luckyRunnerData, this.runnerData.rowData)
      this.$modal.show('editLuckyRunner')
    },
    Save() {
      LuckyLiveRunnerService.updateLuckyLiveRunnerData(this.luckyRunnerData).then(response => {
        this.$emit('saved', response.data)
        this.$modal.hide('editLuckyRunner')
      }).catch(error => {
          console.log("err---",error) 
          this.$modal.hide('editLuckyRunner')
      })          
    }
  },
  created() {
    this.$watch("show", function(val) {})
  },

  watch: {
    show(oldVal, newVal) {
      if (this.show) {
        this.openEditModal()
      }
    }
  }
}
</script>
<style>
.llre-modal .sweet-modal {
  border: 1px solid #e8e8ed;
  border-radius: 14px;
  box-shadow: 0 18px 50px rgba(26, 26, 46, 0.18);
  overflow: hidden;
}

.llre-modal .sweet-content {
  padding: 0;
}

.llre-dialog {
  background: #fff;
}

.llre-dialog-header {
  align-items: center;
  border-bottom: 1px solid #f0f0f5;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 1.25rem 1.75rem;
}

.llre-dialog-header-left {
  align-items: center;
  display: flex;
  gap: 12px;
  min-width: 0;
}

.llre-dialog-icon {
  align-items: center;
  background: #f0effe;
  border-radius: 10px;
  color: #5b4fcf;
  display: inline-flex;
  flex: 0 0 36px;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.llre-dialog-title {
  color: #1a1a2e;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
}

.llre-dialog-sub {
  color: #8a8a9a;
  font-size: 12px;
  line-height: 1.35;
  margin: 4px 0 0;
}

.llre-close-btn {
  align-items: center;
  background: #fff;
  border: 1px solid #e8e8ed;
  border-radius: 8px;
  color: #8a8a9a;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 30px;
  height: 30px;
  justify-content: center;
  transition: all 0.18s ease;
  width: 30px;
}

.llre-close-btn:hover {
  border-color: #f2b8b5;
  color: #c0392b;
}

.llre-dialog-body {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  padding: 1.5rem 1.75rem;
}

.llre-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.llre-label {
  color: #1a1a2e;
  font-size: 12px;
  font-weight: 600;
  margin: 0;
}

.llre-input,
.llre-textarea {
  background: #fafafa;
  border: 1px solid #e8e8ed;
  border-radius: 8px;
  color: #1a1a2e;
  font-size: 14px;
  line-height: 1.4;
  outline: none;
  padding: 0 12px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
  width: 100%;
}

.llre-input {
  height: 40px;
}

.llre-textarea {
  min-height: 96px;
  padding-bottom: 10px;
  padding-top: 10px;
  resize: vertical;
}

.llre-input:focus,
.llre-textarea:focus {
  border-color: #5b4fcf;
  box-shadow: 0 0 0 3px rgba(91, 79, 207, 0.12);
}

.llre-dialog-footer {
  align-items: center;
  border-top: 1px solid #f0f0f5;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 1rem 1.75rem 1.5rem;
}

.llre-cancel-btn,
.llre-save-btn {
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  font-size: 13px;
  font-weight: 600;
  gap: 7px;
  height: 36px;
  justify-content: center;
  padding: 0 18px;
  transition: all 0.18s ease;
}

.llre-cancel-btn {
  background: #fff;
  border: 1.5px solid #e0e0ea;
  color: #5b4fcf;
}

.llre-cancel-btn:hover {
  border-color: #5b4fcf;
}

.llre-save-btn {
  background: #5b4fcf;
  border: none;
  color: #fff;
}

.llre-save-btn:hover {
  background: #4338ca;
}

@media (max-width: 520px) {
  .llre-dialog-header,
  .llre-dialog-body,
  .llre-dialog-footer {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .llre-dialog-footer {
    align-items: stretch;
    flex-direction: column-reverse;
  }

  .llre-cancel-btn,
  .llre-save-btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// EditLuckyLiveRunner.vue?56c31ee0